'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Round number to specified precision
 * @param {number} precision The number of decimal digits to round to.
 * @param {number} float The value to round
 * @returns {number} The rounded value
 * @example
 * toFixed(2, Math.PI) // => 3.14
 */
function toFixed(precision, _float) {
  var divisor = Math.pow(10, precision);
  return Math.round(_float * divisor) / divisor;
}

exports.toFixed = toFixed;
//# sourceMappingURL=to-fixed.js.map
